
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill":"#FF5F00","d":"M12.721 5.283H7.279v9.434h5.442V5.283z"}}),_c('path',{attrs:{"fill":"#EB001B","d":"M7.688 10c0-1.917.933-3.617 2.367-4.717A6.326 6.326 0 006.22 4C2.782 4 0 6.683 0 10s2.782 6 6.22 6a6.326 6.326 0 003.835-1.283A5.917 5.917 0 017.688 10z"}}),_c('path',{attrs:{"fill":"#F79E1B","d":"M20 10c0 3.317-2.782 6-6.22 6a6.326 6.326 0 01-3.835-1.283c1.451-1.1 2.367-2.8 2.367-4.717 0-1.917-.933-3.617-2.367-4.717A6.326 6.326 0 0113.78 4C17.218 4 20 6.7 20 10z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    